import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="bg-[#111111]/60 backdrop-blur-sm rounded-2xl border border-white/[0.08] p-6 md:p-8">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-white mb-4">
          Didn't find what you were looking for? Let's fix it together.
        </h3>
        <Link
          to="/dispute-resolution-form"
          className="inline-block bg-white text-[#0a0a0a] px-6 py-3 rounded-full font-medium hover:bg-white/90 transition-colors whitespace-nowrap text-sm"
        >
          Submit a Dispute Form
        </Link>
      </div>
    </section>
  );
}